module.exports = __webpack_public_path__ + "static/media/univerzalna-pletiva.77449154.png";